import axios from 'axios';

const baseURL = process.env.VUE_APP_API_BASE;

// const TwitchParent = 'localhost';
// const TwitchParent = 'multiview.longshotmedia.com.au';
const TwitchParent = (process.env.NODE_ENV !== 'production' ? 'localhost' : 'multiview.longshotmedia.com.au');

const api = axios.create({
  // baseURL: 'http://127.0.0.1:8800/',
  // baseURL: 'https://multiview-api.friendsproject.in.th/',
  // baseURL: 'https://hub.eventsengine.com.au/multiview_api',
  // baseURL: 'https://multiview.longshotmedia.com.au/multiview_api',
  // baseURL: '/multiview_api',
  baseURL,
  timeout: 5000,
});

export {
  api,
  TwitchParent
};